import { render, staticRenderFns } from "./issues-list.vue?vue&type=template&id=06d05a2a&"
import script from "./issues-list.vue?vue&type=script&lang=js&"
export * from "./issues-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports